import once from 'lodash/once';
import { createContext, Dispatch, SetStateAction } from 'react';

/** Represents the favorite toggle function. */
export type FavoriteToggleFn = () => void;

/** The favorite item layout context. */
export const getFavoriteItemLayoutContext = once(<TItem>() =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  createContext<{
    /** The item. */
    readonly item: TItem;
    /** Whether the item is favorited. */
    readonly isFavorite: boolean;
    /** The callback for whenever the favorite should be toggled. */
    readonly setFavoriteToggle: Dispatch<
      SetStateAction<FavoriteToggleFn | undefined>
    >;
    /** The callback for whenever the favorite is disabled. */
    readonly setIsFavoriteDisabled: Dispatch<SetStateAction<boolean>>;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  }>(undefined!),
);
